module.exports = __webpack_public_path__ + "img/logo.898c9391.png";